import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PublicHeader from './PublicHeader';
import { supabase } from './supabaseClient';
import { setCustomerSession } from './customerSession';
import './PublicHome.css';
import './CustomerAuth.css';

function parseRpcResult(data) {
  if (data == null) return null;
  if (typeof data === 'object' && !Array.isArray(data)) return data;
  if (typeof data === 'string') {
    try {
      return JSON.parse(data);
    } catch {
      return null;
    }
  }
  return null;
}

function CustomerSignIn() {
  const navigate = useNavigate();
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [busy, setBusy] = React.useState(false);
  const [error, setError] = React.useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!supabase) {
      setError(
        'Supabase is not configured. Add REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY to .env.local.'
      );
      return;
    }

    setBusy(true);
    try {
      const { data, error: rpcError } = await supabase.rpc('login_customer', {
        p_email: email.trim(),
        p_password: password,
      });

      if (rpcError) throw rpcError;

      const row = parseRpcResult(data);
      if (!row || !row.ok) {
        setError(row?.error || 'Could not sign in.');
        return;
      }

      setCustomerSession({
        userId: row.user_id,
        email: row.email,
        fullName: row.full_name,
      });
      navigate('/', { replace: true });
    } catch (err) {
      setError(err?.message || 'Could not sign in. Run sql/add_customer_accounts_supabase.sql in Supabase.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="ph-root ct-page">
      <PublicHeader />

      <main className="ca-page">
        <div className="ca-card">
          <h1 className="ca-title">Sign in</h1>
          <p className="ca-lead">
            Access your ODUS customer account to save favourites and manage enquiries.
          </p>

          <form className="ca-form" onSubmit={handleSubmit}>
            {error ? (
              <p className="ca-error" role="alert">
                {error}
              </p>
            ) : null}

            <div className="ca-field">
              <label className="ca-label" htmlFor="ca-signin-email">
                Email
              </label>
              <input
                id="ca-signin-email"
                className="ca-input"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
              />
            </div>

            <div className="ca-field">
              <label className="ca-label" htmlFor="ca-signin-password">
                Password
              </label>
              <input
                id="ca-signin-password"
                className="ca-input"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Your password"
              />
            </div>

            <button type="submit" className="ph-btn ph-btn-primary ca-submit" disabled={busy}>
              {busy ? 'Signing in…' : 'Sign in'}
            </button>
          </form>

          <p className="ca-footer">
            Don&apos;t have an account?{' '}
            <Link to="/sign-up" className="ca-footer-link">
              Sign up
            </Link>
          </p>
        </div>
      </main>
    </div>
  );
}

export default CustomerSignIn;
